/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CAUSE_FAULT_GROUPS } from '../../actions.type'
import {
  CREATE_CAUSE_FAULT_GROUP,
  REMOVE_CAUSE_FAULT_GROUP,
  SET_CAUSE_FAULT_GROUP_ALL_REQUEST,
  SET_CAUSE_FAULT_GROUP_ALL_VALUE,
  UPDATE_CAUSE_FAULT_GROUP
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  causeFaultGroupAllValue: (state) => state.all.value,
  causeFaultGroupAllRequest: (state) => state.all.request,
  causeFaultGroupAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_CAUSE_FAULT_GROUPS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('cause-fault-group', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CAUSE_FAULT_GROUP_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CAUSE_FAULT_GROUP_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CAUSE_FAULT_GROUP_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CAUSE_FAULT_GROUP_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CAUSE_FAULT_GROUP_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CAUSE_FAULT_GROUP({ commit }, value) {
    commit(CREATE_CAUSE_FAULT_GROUP, value)
  },

  async SOCKET_UPDATE_CAUSE_FAULT_GROUP({ commit }, value) {
    commit(UPDATE_CAUSE_FAULT_GROUP, value)
  },

  async SOCKET_REMOVE_CAUSE_FAULT_GROUP({ commit }, id) {
    commit(REMOVE_CAUSE_FAULT_GROUP, id)
  }
}

const mutations = {
  [SET_CAUSE_FAULT_GROUP_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CAUSE_FAULT_GROUP_ALL_VALUE](state, causeFaultGroups) {
    state.all.value = causeFaultGroups
  },
  [UPDATE_CAUSE_FAULT_GROUP](state, updatedCauseFaultGroup) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedCauseFaultGroup.id }),
      1,
      updatedCauseFaultGroup
    )
  },
  [CREATE_CAUSE_FAULT_GROUP](state, createdCauseFaultGroup) {
    state.all.value.push(createdCauseFaultGroup)
  },
  [REMOVE_CAUSE_FAULT_GROUP](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
